import { InputLabel, styled } from "@mui/material";

export const MyInputLable = styled(InputLabel)`
  && {
    //styleName: Text/Regular/Normal;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-transform: capitalize;
    color: #344054;
  }
`;
